import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import datavedam from "./asset/datavedam.jpeg";
import hiringhippo from "./asset/hiringhippo.jpeg";
import ihm from "./asset/ihm.jpeg";
import sankir from "./asset/sankir.jpeg";
import tailor from "./asset/tailor.jpeg";

export class All extends Component {
  static propTypes = {};

  render() {
    const projectList = [
      {
        url: datavedam,
        name: "Datavedam",
        link: "https://tailor-4b6c6.web.app/ ",
      },
      {
        url: hiringhippo,
        name: "HiringHippo",
        link: "https://tailor-4b6c6.web.app/ ",
      },
      {
        url: ihm,
        name: "IHM Bangalore",
        link: "https://tailor-4b6c6.web.app/ ",
      },
      {
        url: sankir,
        name: "Sankir Technology",
        link: "https://tailor-4b6c6.web.app/ ",
      },
      {
        url: tailor,
        name: "Tailor",
        link: "/https://tailor-4b6c6.web.app/ ",
      },
    ];
    return (
      <>
        <section className="all-projects">
          {projectList.map((projet) => {
            return (
              <Link target="_blank" hrefLang="https://tailor-4b6c6.web.app/ ">
                <div className="items">
                  <img src={projet.url} alt="" />
                  <h1>{projet.name}</h1>
                </div>
              </Link>
            );
          })}
        </section>
      </>
    );
  }
}

export default All;
